import React from 'react'
import css from './style.css'

const Spacer = props => {
  // xxs, xs, sm, md, lg, or xl

  var classes = [
    css.spacer,
    props.xxs ? css.xxs : '',
    props.xs ? css.xs : '',
    props.sm ? css.sm : '',
    props.md ? css.md : '',
    props.lg ? css.lg : '',
    props.xl ? css.xl : '',
    props.className
  ]

  if (props.custom) {
    return <div className={classes.join(' ')} style={{ 'padding': `${props.custom}px 0px`, display: props.hide ? 'none' : 'block' }} />
  }
  return <div className={classes.join(' ')} style={{ display: props.hide ? 'none' : 'block' }} />
}

export default Spacer



// WEBPACK FOOTER //
// ./src/components/spacer/index.js